module.exports = __webpack_public_path__ + "img/widget.401a6d7a.svg";